// extracted by mini-css-extract-plugin
module.exports = {"container":"_815c679","withTitle":"_255be51"};